/**
 * zel-finance.doseo
 * @since       16.11.2017 22:47
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

export default function(target, replacement) {

  if (!target instanceof HTMLElement || !target.innerHTML) {
    console.warn('autoReplace: Invalid first argument, HTMLElement expected');
    return;
  }

  if (!(replacement && typeof replacement === 'object')) {
    console.warn('autoReplace: Invalid second argument, Object expected');
    return;
  }

  for (let key in replacement) {
    if (replacement.hasOwnProperty(key)) {
      let re           = new RegExp(`\\[${key}\\]`, 'g');
      target.innerHTML = target.innerHTML.replace(re, replacement[key]);
    }
  }
}



// WEBPACK FOOTER //
// ./source/js/components/autoReplace.js